import { fetchProfile } from "./fetch-profile";
import { startCampaignFromAudience } from "./start-campaign-from-audience";
import { createCustomersReport } from "@/module/crm/repo/create-customers-report";

export const crmRepo = {
  getProfile: fetchProfile,
  createCustomersReport: createCustomersReport,
  startCampaignFromAudience: startCampaignFromAudience,
};
